import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderSlot as _renderSlot, withCtx as _withCtx, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "table-view" }
const _hoisted_2 = { class: "table-view-content" }
const _hoisted_3 = { class: "panel" }
const _hoisted_4 = { class: "row align-items-center" }
const _hoisted_5 = { class: "col-auto ml-auto" }
const _hoisted_6 = {
  key: 0,
  class: "row"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", {
  class: "pb-2 pt-4 col-12",
  style: {"text-align":"center"}
}, " Нет данных ", -1)
const _hoisted_8 = [
  _hoisted_7
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_tirscript3_loading = _resolveComponent("tirscript3-loading")!
  const _component_bs_col = _resolveComponent("bs-col")!
  const _component_bs_row = _resolveComponent("bs-row")!
  const _component_tirscript3_pagination = _resolveComponent("tirscript3-pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_bs_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_bs_col, null, {
            default: _withCtx(() => [
              _createVNode(_component_tirscript3_loading, { loading: _ctx.isLoading }, null, 8, ["loading"]),
              _renderSlot(_ctx.$slots, "content", { items: _ctx.innerItems })
            ]),
            _: 3
          })
        ]),
        _: 3
      }),
      _withDirectives(_createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_tirscript3_pagination, {
              ref: "pagination",
              size: _ctx.countPerPage,
              count: _ctx.totalItems,
              class: "mt-4",
              onOnChange: _ctx.onPaginationChanged
            }, null, 8, ["size", "count", "onOnChange"])
          ])
        ])
      ], 512), [
        [_vShow, !_ctx.noPagination && _ctx.innerItems && _ctx.innerItems.length > 0]
      ]),
      (
          !_ctx.noPagination &&
          _ctx.innerItems &&
          _ctx.innerItems.length == 0 &&
          _ctx.isLoading == false
        )
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_8))
        : _createCommentVNode("", true)
    ])
  ]))
}